import script from "./ScrollNoitce.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScrollNoitce.vue?vue&type=script&lang=ts&setup=true"

import "./ScrollNoitce.vue?vue&type=style&index=0&id=1bc25470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc25470"]])

export default __exports__